import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/jobFunctions/jobDrawingActions'
import * as api from '../../api/job/drawings'

function* jobDrawingsRefresh(action) {
  try {
    const payload = yield call(api.getJobDrawings, action.jobId)
    yield put({ type: constants.JOB_DRAWINGS_REFRESH.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_DRAWINGS_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* watchJobDrawings() {
  yield takeLatest(constants.JOB_DRAWINGS_REFRESH.ACTION, jobDrawingsRefresh)
}

function* sagaUpdateJobDrawing(action) {
  try {
    const payload = {
      job_drawing_id: action.drawingId,
      job_id: action.jobId,
      status: action.drawingStatus,
      drawing_type: action.drawingType,
      description: action.description,
      updated_by_id: action.userId,
      user_id: action.userId
    }

    yield call(api.updateJobDrawing, payload)
    yield put({ type: constants.JOB_DRAWING_UPDATE.SUCCESS, payload })
    yield call(jobDrawingsRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_DRAWING_UPDATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateJobDrawing() {
  yield takeLatest(constants.JOB_DRAWING_UPDATE.ACTION, sagaUpdateJobDrawing)
}

function* sagaCreateJobDrawing(action) {
  try {
    const payload = {
      job_id: action.jobId,
      drawing_type: action.drawingType,
      description: action.description,
      updated_by_id: action.userId,
      created_by_id: action.userId
    }
    yield call(api.createJobDrawing, payload)
    yield put({ type: constants.JOB_DRAWING_CREATE.SUCCESS, payload })
    yield call(jobDrawingsRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_DRAWING_CREATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateJobDrawing() {
  yield takeLatest(constants.JOB_DRAWING_CREATE.ACTION, sagaCreateJobDrawing)
}

function* sagaDeleteJobDrawing(action) {
  try {
    const payload = {
      job_drawing_id: action.drawingId
    }
    yield call(api.deleteJobDrawing, payload)
    yield put({ type: constants.JOB_DRAWING_DELETE.SUCCESS, payload })
    yield call(jobDrawingsRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_DRAWING_DELETE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteJobDrawing() {
  yield takeLatest(constants.JOB_DRAWING_DELETE.ACTION, sagaDeleteJobDrawing)
}

// ATTACHMENT SAGAS
function* uploadDrawingAttachments(action) {
  try {
    const payload = {
      formData: action.formData,
      drawingId: action.drawingId
    }

    yield call(api.uploadDrawingAttachments, payload)
    yield put({ type: constants.UPLOAD_DRAWING_ATTACHMENT.SUCCESS, payload })
    yield call(getDrawingAttachments, { drawingId: action.drawingId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPLOAD_DRAWING_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchUploadDrawingAttachments() {
  yield takeLatest(constants.UPLOAD_DRAWING_ATTACHMENT.ACTION, uploadDrawingAttachments)
}

function* getDrawingAttachments(action) {
  try {
    const payload = yield call(api.getDrawingAttachments, action.drawingId)
    yield put({ type: constants.GET_DRAWING_ATTACHMENTS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_DRAWING_ATTACHMENTS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetDrawingAttachments() {
  yield takeLatest(constants.GET_DRAWING_ATTACHMENTS.ACTION, getDrawingAttachments)
}

function* updateDrawingAttachmentDescription(action) {
  try {
    const payload = {
      attachmentId: action.attachmentId,
      created_by_id: action.userId,
      updated_by_id: action.userId,
      user_id: 1,
      description: action.description,
      status: action.status
    }
    yield call(api.updateAttachmentDescription, payload)
    yield put({ type: constants.UPDATE_DRAWING_ATTACHMENT_DESCRIPTION.SUCCESS, payload })
    yield call(getDrawingAttachments, { drawingId: action.drawingId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPDATE_DRAWING_ATTACHMENT_DESCRIPTION.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateDrawingAttachmentDescription() {
  yield takeLatest(
    constants.UPDATE_DRAWING_ATTACHMENT_DESCRIPTION.ACTION,
    updateDrawingAttachmentDescription
  )
}

function* deleteDrawingAttachment(action) {
  try {
    const payload = {
      attachmentId: action.attachmentId,
      drawingId: action.drawingId
    }

    yield call(api.deleteDrawingAttachment, payload)
    yield put({ type: constants.DELETE_DRAWING_ATTACHMENT.SUCCESS, payload })
    yield call(getDrawingAttachments, { drawingId: action.drawingId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_DRAWING_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteDrawingAttachments() {
  yield takeLatest(constants.DELETE_DRAWING_ATTACHMENT.ACTION, deleteDrawingAttachment)
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchJobDrawings),
    fork(watchCreateJobDrawing),
    fork(watchUpdateJobDrawing),
    fork(watchDeleteJobDrawing),

    fork(watchUploadDrawingAttachments),
    fork(watchGetDrawingAttachments),
    fork(watchUpdateDrawingAttachmentDescription),
    fork(watchDeleteDrawingAttachments)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/jobFunctions/jobDrawingSaga.js